
import React, { useEffect, useState } from 'react';
import { getEasternTime } from '../../helpers/dateHelpers';
import './CountdownTimer.scss';

export default function CountdownTimer({biddingClosedWithTime,sdoAdminReport}) {
    
    const [timeLeft, setTimeLeft] = useState({days: 0, hours: 0, minutes: 0});
    const [nextSdoSubmissionPeriodFlag, setNextSdoSubmissionPeriodFlag] = useState(false);

    const getTimeLeft = (endtime = biddingClosedWithTime) => {
        const difference = new Date(endtime).getTime() - getEasternTime().getTime();
        let temp = {days: 0, hours: 0, minutes: 0};
        if (difference > 0) {
          temp = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
          };
        }
        return temp;
      }

    const getCountDownTimer = () => {
      let t = getTimeLeft();
      setTimeLeft(t);
      getNextSdoSubmissionPeriod(t);

      setInterval(() => {
        setTimeLeft(getTimeLeft());
      }, 60000);
    }

    useEffect(() => {
      getCountDownTimer(); 
      
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getNextSdoSubmissionPeriod = (t) => {
      const timeLeft = (t.days * 24 * 60) + (t.hours * 60) + (t.minutes)
      if (timeLeft <= 1440) setNextSdoSubmissionPeriodFlag(true);
    }

    return (
      <>{sdoAdminReport ? 
      <span className={nextSdoSubmissionPeriodFlag? 'timer-sdo-admin-red':'timer-sdo-admin'}>
        {(!timeLeft.days && !timeLeft.hours && !timeLeft.minutes) ? '00d 00h 00m' : `${timeLeft.days}d   ${timeLeft.hours}hrs   ${timeLeft.minutes}mins`}
      </span> :
        <span className='timer'>
          {(!timeLeft.days && !timeLeft.hours && !timeLeft.minutes) ? '' :`${timeLeft.days}d : ${timeLeft.hours}h : ${timeLeft.minutes}m` }
        </span>
      }
      </>
    );
}
